export function staffHasProductGroup(person, coverage) {
  const ids = person?.product_group_ids;
  if (Array.isArray(ids)) return ids.length > 0;
  return Number(coverage?.required_count) > 0;
}

/** complete | incomplete | none (no assigned groups, or coverage not loaded) */
export function staffCompletion(person, coverage) {
  if (!staffHasProductGroup(person, coverage)) return "none";
  if (!coverage || Number(coverage.required_count) === 0) return "none";
  return coverage.is_complete ? "complete" : "incomplete";
}

export function matchesStaffSearch(person, query) {
  const text = String(query || "").trim().toLowerCase();
  if (!text) return true;
  const fields = [person?.full_name, person?.personnel_code, person?.national_code];
  return fields.some((value) => String(value || "").toLowerCase().includes(text));
}

export function matchesStaffListFilters(
  person,
  coverage,
  { completion = "all", group = "all" } = {},
) {
  const hasGroup = staffHasProductGroup(person, coverage);
  if (group === "with" && !hasGroup) return false;
  if (group === "without" && hasGroup) return false;

  const status = staffCompletion(person, coverage);
  if (completion === "complete" && status !== "complete") return false;
  if (completion === "incomplete" && status !== "incomplete") return false;
  return true;
}
